import type { TextPart } from '../../../types';

import { findCommandWords } from '../../../util/jaryanCommandWords';

// Draws each command word of a message's plain text in an isolate, so a command inside a sentence in another
// direction keeps its own. Only text that lies outside every entity is passed here: an entity is already
// drawn as an element with a direction of its own.
export default function isolateCommandWords(parts: TextPart[], isHtml?: boolean): TextPart[] {
  if (isHtml) return parts;

  return parts.flatMap((part) => {
    if (typeof part !== 'string') return [part];

    const words = findCommandWords(part);
    if (!words.length) return [part];

    const result: TextPart[] = [];
    let index = 0;
    words.forEach(({ start, end }) => {
      if (start > index) result.push(part.slice(index, start));
      result.push(<bdi className="command-word">{part.slice(start, end)}</bdi>);
      index = end;
    });
    if (index < part.length) result.push(part.slice(index));

    return result;
  });
}
